import { render } from "./KryptonLabel.vue?vue&type=template&id=3e3882ae&lang=pug"
import script from "./KryptonLabel.vue?vue&type=script&lang=js"
export * from "./KryptonLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__